import { isPlatformBrowser } from '@angular/common'
import { inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core'

import { environment } from 'environments/environment'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

@Injectable({ providedIn: 'root' })
export class EchoService {
  private platformId = inject(PLATFORM_ID)
  private echo: Echo<any>

  constructor() {
    inject(NgZone).runOutsideAngular(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.initEcho()
      }
    })
  }

  // Local echo config
  // private initEcho() {
  //   ;(Window as any).Pusher = Pusher
  //   this.echo = new Echo({
  //     broadcaster: 'reverb',
  //     key: environment.REVERB_APP_KEY,
  //     wsHost: environment.REVERB_WS_HOST,
  //     wsPort: '8080',
  //     wssPort: '8080',
  //     forceTLS: false,
  //     enabledTransports: ['ws', 'wss']
  //   })
  // }
  private initEcho() {
    ;(Window as any).Pusher = Pusher
    this.echo = new Echo({
      broadcaster: 'reverb',
      key: environment.REVERB_APP_KEY,
      wsHost: environment.REVERB_WS_HOST,
      forceTLS: false,
      enabledTransports: ['ws', 'wss']
    })
  }

  /**
   *
   * @param channelName
   * @param eventName
   * @param callback
   *
   * @return boolean - Active status
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  listen(channelName: string, eventName: string, callback: Function) {
    if (this.echo) {
      this.echo.channel(channelName).listen(eventName, callback)
      return true
    }

    return false
  }

  disconnect() {
    if (this.echo) {
      this.echo.disconnect()
    }
  }
}
